import { FormStepStateAction, FormStepsState, Reducer, ReducerActions, formStepActions } from '@/context/types';

const makeFormStepInitialState = (steps: number): FormStepsState => ({
  steps,
  current: 1,
  percent: Math.round(100 / steps),
});

const toggleStep = (state: FormStepsState, direction: 'prev' | 'next') => {
  if ((direction === 'prev' && state.current === 1) || (direction === 'next' && state.current === state.steps)) {
    return {};
  }

  const equivalence = 100 / state.steps;
  const current = direction === 'next' ? state.current + 1 : state.current - 1;
  const percent = Math.round(current * equivalence);

  return { current, percent };
};

const reducerActions: ReducerActions<FormStepsState, FormStepStateAction> = (state, payload) => ({
  form_step_next: () => ({ ...state, ...toggleStep(state, 'next') }),
  form_step_prev: () => ({ ...state, ...toggleStep(state, 'prev') }),
  form_step_reset: () => ({ ...state, ...makeFormStepInitialState(payload) }),
});

export const formStepReducer: Reducer<FormStepsState, FormStepStateAction> = (state, { action, payload }) =>
  formStepActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state };

formStepReducer.key = 'formSteps';
formStepReducer.initialState = makeFormStepInitialState(5);
